// extracted by mini-css-extract-plugin
module.exports = {"dot-divider":"styles-module--dot-divider--3DihT","dotDivider":"styles-module--dot-divider--3DihT"};